import iconBus from 'assets/icons/bus.svg'
import iconGrill from 'assets/icons/grill.svg'
import iconPlayground from 'assets/icons/playground.svg'
import iconShops from 'assets/icons/shops.svg'
import iconCards from 'assets/icons/cards.svg'
import iconSlide from 'assets/icons/slide.svg'
import iconBicycle from 'assets/icons/bicycle.svg'
import iconAnimal from 'assets/icons/animal.svg'

import banerOrange from 'assets/images/accommodation/banerOrange.svg'
import banerBlue from 'assets/images/accommodation/banerBlue.svg'

import iconDoubleBed from 'assets/icons/doubleBed.svg'
import iconSingleBed from 'assets/icons/singleBed.svg'
import iconSofa from 'assets/icons/sofa.svg'
import iconCoffee from 'assets/icons/coffee.svg'
import iconShower from 'assets/icons/shower.svg'

import { defineMessage } from 'react-intl'
import { BUNGALOW_DUO_PRICE, BUNGALOW_PRICE } from 'constants/prices'

export const amenities = [
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_kitchenette',
            defaultMessage: 'Aneks kuchenny',
        }),
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_terrace',
            defaultMessage: 'Taras',
        }),
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_barbecue',
            defaultMessage: 'Grill wolnostojący',
        }),
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_wifi',
            defaultMessage: 'Darmowa sieć WiFi',
        }),
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_hairdryer',
            defaultMessage: 'Suszarka do włosów',
        }),
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_ironing_set',
            defaultMessage: 'Zestaw do prasowania',
        }),
        additionalText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_on_request',
            defaultMessage: 'na życzenie – według dostępności',
        }),
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_parking',
            defaultMessage: 'Darmowy parking',
        }),
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_safe',
            defaultMessage: 'Sejf',
        }),
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_double_sofa',
            defaultMessage: 'Rozkładana dwuosobowa sofa',
        }),
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_air_conditioning',
            defaultMessage: 'Klimatyzacja',
        }),
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_baby_bed',
            defaultMessage: 'Łóżeczko dla dziecka',
        }),
        additionalText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_on_request',
            defaultMessage: 'na życzenie – według dostępności',
        }),
    },
]

export const additionalServices = [
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.services_shop',
            defaultMessage: 'Sklep ze świeżymi produktami i gotowymi posiłkami',
        }),
        icon: iconShops,
        iconAlt: 'shops icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.services_bus',
            defaultMessage: 'Ekologiczny bus do i z parku Suntago',
        }),
        icon: iconBus,
        iconAlt: 'bus icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.services_barbecue_zone',
            defaultMessage: 'Strefa na ognisko / wspólna strefa grillowa',
        }),
        icon: iconGrill,
        iconAlt: 'grill icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.services_playground',
            defaultMessage: 'Plac zabaw',
        }),
        icon: iconPlayground,
        iconAlt: 'playground icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.services_fast_pass',
            defaultMessage: 'Fast Pass do parku dla gości Suntago Village',
        }),
        icon: iconCards,
        iconAlt: 'tickets icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.services_water_park',
            defaultMessage: 'Atrakcje parku wodnego',
        }),
        additionalText: defineMessage({
            id: 'accommodation.bungalow_modal.services_paid_additionally',
            defaultMessage: '(dodatkowo płatne)',
        }),
        icon: iconSlide,
        iconAlt: 'slide icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.services_bicycles',
            defaultMessage: 'Płatny wynajem rowerów',
        }),
        icon: iconBicycle,
        iconAlt: 'bicycle icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.services_animal_friendly',
            defaultMessage: 'Obiekt przyjazny zwierzętom',
        }),
        icon: iconAnimal,
        iconAlt: 'animal icon',
    },
]

export const bungalowBannersData = [
    {
        bannerVersion: banerOrange,
        bungalowName: 'Bungalow',
        maxGuests: 4,
        doubleBedNo: 1,
        singleBedNo: 2,
        sofaNo: 1,
        kitchenNo: 1,
        bathroomNo: 1,
        price: BUNGALOW_PRICE,
    },
    {
        bannerVersion: banerBlue,
        bungalowName: 'Bungalow Duo',
        maxGuests: 8,
        doubleBedNo: 2,
        singleBedNo: 4,
        sofaNo: 2,
        kitchenNo: 2,
        bathroomNo: 2,
        price: BUNGALOW_DUO_PRICE,
    },
]

export const bungalowBannerStaticInfo = [
    {
        icon: iconDoubleBed,
        iconAlt: 'double bed icon',
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_double_bed',
            defaultMessage: 'łóżko dwuosobowe',
        }),
        text: defineMessage({
            id: 'accommodation.bungalow_modal.or_divider',
            defaultMessage: ' lub',
        }),
    },
    {
        icon: iconSingleBed,
        iconAlt: 'single bed icon',
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_single_bed',
            defaultMessage: 'łóżko jednoosobowe',
        }),
        borderBottom: true,
    },
    {
        icon: iconSofa,
        iconAlt: 'sofa icon',
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_sofa',
            defaultMessage: 'rozkładana sofa',
        }),
        text: defineMessage({
            id: 'accommodation.bungalow_modal.people_capacity',
            defaultMessage: ' (2 os.)',
        }),
        borderBottom: true,
    },
    {
        icon: iconCoffee,
        iconAlt: 'coffee icon',
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_kitchenette',
            defaultMessage: 'aneks kuchenny',
        }),
    },
    {
        icon: iconShower,
        iconAlt: 'shower icon',
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_bathroom',
            defaultMessage: 'łazienka',
        }),
        borderBottom: true,
    },
]
